import { makeStyles } from "tss-react/mui"
import { lightBlue, lightGreen } from "../../themes/palette"

export const useStyles = makeStyles()(({}) => ({
  copyClickableText: {
    color: lightBlue[600],
    fontSize: "0.75rem",
    lineHeight: "1rem",
    fontWeight: 500,
    textTransform: "uppercase",
    cursor: "pointer",

    "&:hover": {
      color: lightBlue[800]
    }
  },
  copiedState: {
    color: lightGreen[800],

    "&:hover": {
      color: lightGreen[900]
    }
  }
}))
